import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  params: icon('ic-params'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  subpaths: icon('ic-subpaths'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  /**
   * Overview
   */
  {
    subheader: 'Overview',
    items: [
      { title: 'App', path: paths.dashboard.root, icon: ICONS.dashboard },
      {
        title: 'Statistics',
        path: paths.dashboard.statistics.root,
        icon: ICONS.analytics,
      },
      { title: 'Rappels push', path: paths.dashboard.reminders.root, icon: ICONS.mail },
      {
        title: 'Marketing',
        path: paths.dashboard.marketing.root,
        icon: ICONS.banking,
      },
      { title: 'Acquisition', path: paths.dashboard.acquisition.root, icon: ICONS.subpaths },
      {
        title: 'Ops',
        path: paths.dashboard.ops.root,
        icon: ICONS.dashboard,
      },
      {
        title: 'Moderation',
        path: paths.dashboard.moderation.root,
        icon: ICONS.blog,
      },
    ],
  },
  /**
   * Management
   */
  {
    subheader: 'Management',
    items: [
      {
        title: 'Enterprise',
        path: paths.dashboard.enterprise.root,
        icon: ICONS.banking,
        children: [
          { title: 'List', path: paths.dashboard.enterprise.list },
          { title: 'Create', path: paths.dashboard.enterprise.create },
        ],
      },
      {
        title: 'Location',
        path: paths.dashboard.location.root,
        icon: ICONS.kanban,
        children: [
          { title: 'Map', path: paths.dashboard.location.map },

          { title: 'List', path: paths.dashboard.location.list },
          { title: 'Create', path: paths.dashboard.location.create },
          {
            title: 'Marker',
            path: paths.dashboard.location.marker.root,
            children: [
              { title: 'List', path: paths.dashboard.location.marker.list },
              { title: 'Create', path: paths.dashboard.location.marker.create },
            ],
          },
        ],
      },
      {
        title: 'App User',
        path: paths.dashboard.appUser.root,
        icon: ICONS.user,
        children: [
          { title: 'List', path: paths.dashboard.appUser.list },
          { title: 'Suggested', path: paths.dashboard.appUser.suggested },
          { title: 'Sans localisation', path: paths.dashboard.appUser.withoutLocation },
        ],
      },
      {
        title: 'Admin User',
        path: paths.dashboard.adminUser.root,
        icon: ICONS.user,
        children: [
          { title: 'List', path: paths.dashboard.adminUser.list },
          { title: 'Create', path: paths.dashboard.adminUser.create },
        ],
      },
      {
        title: 'Communications',
        path: paths.dashboard.communications.root,
        icon: ICONS.chat,
        children: [
          { title: 'List', path: paths.dashboard.communications.list },
          { title: 'Create', path: paths.dashboard.communications.create },
        ],
      },
      {
        title: 'Publicity',
        path: paths.dashboard.publicity.root,
        icon: ICONS.external,
        children: [
          { title: 'List', path: paths.dashboard.publicity.list },
          { title: 'Create', path: paths.dashboard.publicity.create },
        ],
      },
      // KAN-788 — the event pages of onfitapp.com/evenements.
      {
        title: 'Événements',
        path: paths.dashboard.siteEvents.root,
        icon: ICONS.calendar,
        children: [
          { title: 'Liste', path: paths.dashboard.siteEvents.list },
          { title: 'Nouvel événement', path: paths.dashboard.siteEvents.create },
        ],
      },
    ],
  },
  /**
   * Support
   */
  {
    subheader: 'Support',
    items: [
      {
        title: 'Reports',
        path: paths.dashboard.reports.root,
        icon: ICONS.file,
        children: [
          { title: 'Training Reports', path: paths.dashboard.reports.trainings },
          { title: 'Place Reports', path: paths.dashboard.reports.places },
          { title: 'User Reports', path: paths.dashboard.reports.users },
        ],
      },
      {
        title: 'Feedback',
        path: paths.dashboard.feedback.root,
        icon: ICONS.analytics,
        children: [{ title: 'Account Deletion', path: paths.dashboard.feedback.accountDeletion }],
      },
      {
        title: 'Support',
        path: paths.dashboard.support.root,
        icon: ICONS.chat,
        children: [{ title: 'Tickets', path: paths.dashboard.support.tickets }],
      },
    ],
  },
  /**
   * Debug
   */
  {
    subheader: 'Debug',
    items: [
      {
        title: 'Explore',
        path: paths.dashboard.debug.explore.root,
        icon: ICONS.params,
        children: [
          { title: 'Map', path: paths.dashboard.debug.explore.map },
          { title: 'Deck', path: paths.dashboard.debug.explore.deck },
          { title: 'Matches', path: paths.dashboard.debug.explore.matches },
        ],
      },
    ],
  },
];
